import React from 'react';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import AddToCart from './AddToCart';
import Promotions from '../../../desktop/product/Promotions';
import ColorVariant from '../../../desktop/product/ColorVariant';
import SizeVariant from '../../../desktop/product/SizeVariant';
import properties from '../../../../modules/ajio-util/properties';
import { generateEvent } from '../../../../utils/dataGrinch';
import {
  getVolumeAndSizeFlag,
  filterTrustmarkerImage,
  getIsPriceRevealPDP,
  getSaleDuration
} from '../../../../utils/pdp';
import { getHurryMsgInvCap } from '../../../../Flags/selectors';
import luxeScreen from '../../../../refresh/constants/luxeScreenType';
import { gtmEventPush } from '../../../../modules/ga/GTMdatalayer';
import {
  getLuxeFlags,
  getEarlyAccessFlag,
  getPriceRevealV2WebFeatureFlag,
  getPriceRevealWebData,
  getPriceRevealLUXEFlag
} from '../../../../Flags/selectors';
import { getCurrentStore } from '../../../../refresh/selectors/metaData';
import { SHOW_MRP_TEXT, PRE_BUZZ, DURING_SALE } from '../../PriceRevealPLPBanner/messages';
import { displayValueWithSymbol } from '../../../../utils/price';
import { isCatalogNameInFirebaseStore } from '../../../../utils/common';
import { Feature, Variant } from '../../../../refresh/organism/ABFeature';
import { signInCheck } from '../../CheckUserStatus';
import { checkEarlyAccessUser } from '../../Cookie';
import {
  getShowPDPRateSection,
  getEnableRating,
  getStoresForHidingMRP,
  getRatingsColorConfig
} from '../../../../refresh/selectors/featureFlagsSelector';
import RatingLabel from '../../../../refresh/atoms/RatingLabel';
import Freebies from '../../Freebies';
import { replaceWithJioCDN } from '../../../../utils/imageHandling';

const isSignedIn = signInCheck();
class Description extends React.Component {
  constructor(props) {
    super(props);
    this.isPriceRevealV2 = false;
    this.textContent = {
      additionalGST: 'Additional GST may apply'
    };
  }

  componentDidMount() {
    let {
      productData = {},
      priceRevealV2WebFeatureFlag,
      priceRevealV2WebData,
      metadata,
      priceRevealLUXEFlag
    } = this.props;
    const { sis, name } = metadata || {};

    const store = sis ? name : 'AJIO';

    this.isPriceRevealV2 = getIsPriceRevealPDP(
      priceRevealV2WebFeatureFlag,
      priceRevealV2WebData,
      productData,
      store,
      priceRevealLUXEFlag
    );
  }

  onActionClick = e => {
    e.preventDefault();
    const { productData, newDesignLuxe } = this.props;
    let { url } = productData;

    const { plp: { screenType = '', screenName = '' } = {} } = luxeScreen;
    window.location.href = `${url}`;

    if (newDesignLuxe) {
      gtmEventPush({
        event: 'plp_product_detail',
        event_category: 'quick_view_interactions',
        event_action: 'product detail click',
        store_type: 'luxe',
        screen_name: screenName,
        screen_type: screenType
      });
    }
  };

  showPriceRevealPreBuzz = () => {
    const { productData } = this.props || {};
    const { saleStartTime, saleEndTime, futureBestPrice } = productData || {};
    const saleDuration = getSaleDuration(saleStartTime, saleEndTime);
    return futureBestPrice && saleDuration === PRE_BUZZ;
  };

  render() {
    let {
      productData = {},
      onSelectColor,
      selectedSizeName,
      newDesignLuxe,
      earlyAccessFlag,
      currentStore,
      enableRating,
      showPDPRateSection,
      storesForHidingMRP
    } = this.props;
    let {
      saleStartTime,
      saleEndTime,
      giftPromotion: { totalGiftCount: freebiesItemsCount = 0, gifts: freebiesItemsList = [] } = {}
    } = productData;
    const isPreBuzz = this.isPriceRevealV2 && this.showPriceRevealPreBuzz();
    const isDuringSale =
      this.isPriceRevealV2 && getSaleDuration(saleStartTime, saleEndTime) === DURING_SALE;
    const isPreSale =
      this.isPriceRevealV2 && getSaleDuration(saleStartTime, saleEndTime) === PRE_BUZZ;
    const isEarlyAccessUser =
      isSignedIn && earlyAccessFlag && checkEarlyAccessUser(currentStore, 'plp') && isPreSale;
    let {
      url,
      images,
      tagResponse: { tag: { categoryTags = [] } = {} } = {}
    } = productData;
    let { catalog } = productData;
    let sizeToolTip;
    let sizeGuide = {};
    let modelData;
    let strikePrice = '';
    let discountPercent = '';
    let stockLevelStatus = 'outOfStock';
    if (productData.featureData) {
      modelData = productData.featureData;
    }
    if (productData?.fnlColorVariantData && productData?.fnlColorVariantData?.sizeGuideDesktop) {
      sizeGuide = JSON.parse(productData.fnlColorVariantData.sizeGuideDesktop);
    }
    // const { sizeGuideDesktop = '' } = productData?.fnlColorVariantData;
    const { sizeChart = '' } = sizeGuide;
    if (productData?.fnlColorVariantData && productData?.fnlColorVariantData?.sizeToolTip) {
      sizeToolTip = JSON.parse(productData?.fnlColorVariantData?.sizeToolTip);
    }
    let colorVariant;
    let sizeVariant;
    let sizeFormat;
    productData?.baseOptions?.map((variant, i) => {
      if (variant?.variantType === 'FnlColorVariant') {
        colorVariant = variant;
      } else if (variant?.variantType === 'FnlSizeVariant') {
        sizeVariant = variant?.options;
      }
    });

    if (sizeVariant === undefined) {
      sizeVariant = productData?.variantOptions;
    }
    let selectedColor = colorVariant?.selected?.code;
    if (colorVariant && colorVariant?.options?.length) {
      colorVariant.options.forEach((color, i) => {
        if (color?.stock && color?.stock?.stockLevelStatus !== 'outOfStock') {
          if (color.code === selectedColor) {
            strikePrice = color?.wasPriceData?.displayformattedValue;
            let sp = color?.priceData?.value;
            let cp = color?.wasPriceData?.value;
            let discount;
            if (sp !== cp) {
              discount = Math.round(((cp - sp) / cp) * 100);
              discountPercent = `${discount}% off`;
            }
          }
        }
      });
    } else {
      discountPercent = productData?.discountPercent;
      if (productData.wasPriceData) {
        strikePrice = productData.wasPriceData.displayformattedValue;
      }
    }
    {
      productData.featureData &&
        productData.featureData.map((list, i) => {
          if (list.name === 'Size Format') {
            sizeFormat = list.featureValues[0].value;
          }
        });
    }
    const { price = {} } = productData;
    const { displayformattedValue: sellingPrice = '' } = price;
    const filterByStock = size => {
      if (size.stock && size?.stock?.stockLevelStatus !== 'outOfStock') {
        stockLevelStatus = size?.stock?.stockLevelStatus;
      }
    };
    let filterData = sizeVariant?.filter(filterByStock);
    let { fnlColorVariantData = {}, name, images: primaryImg = [] } = productData;
    let { brandName = '', color = '' } = fnlColorVariantData;
    let pageTitle = `Buy ${color} ${brandName} ${name} | AJIO`;
    let websiteURL = `${properties.getProperty('siteUrl')}${url}`;
    let pdpSocialPrimaryImageUrl = primaryImg[0]?.url;

    const {
      hideSizes,
      appendDesc,
      metalPurity,
      qualifierKey,
      selectedMetalName
    } = getVolumeAndSizeFlag(colorVariant);
    const trustmarkerImages = (images ? images?.filter(filterTrustmarkerImage) : []).slice(0, 3);

    const { ratingsColor = {} } = this.props;
    const {
      thresholdValue = 3,
      ratingBelowThresholdColor = '',
      ratingAboveThresholdColor = ''
    } = ratingsColor;

    const radioProps = {
      totalStarCount: productData?.ratingsResponse?.aggregateRating?.numUserRatings,
      totalRatingCount: productData?.ratingsResponse?.aggregateRating?.averageRating,
      RatingCountBgColor:
        productData?.ratingsResponse?.aggregateRating?.averageRating < thresholdValue
          ? ratingBelowThresholdColor
          : ratingAboveThresholdColor,
      StarCountBgColor: '#ffffff',
      rateDesign: '',
      rateCustomCss: {
        color: '#939393',
        lineHeight: '1.2',
        letterSpacing: '0.28px',
        fontSize: '14px',
        margin: '0.3em 0 0.3em 0.5em'
      },
      productName: productData?.name,
      productId: productData?.code,
      brickCode: productData?.brickCode,
      sourcePage: 'PLP'
    };
    const hideMRP = isCatalogNameInFirebaseStore(storesForHidingMRP, catalog);
    return (
      <div className="prod-content quickview-details">
        <h2 className="brand-name" aria-label={productData?.fnlColorVariantData?.brandName}>{productData?.fnlColorVariantData?.brandName}</h2>
        <h1 className="prod-name" aria-label={`${productData?.name} ${(metalPurity && selectedMetalName) ? ` | ${selectedMetalName}` : ''} ${(appendDesc && selectedSizeName) ? ` | ${selectedSizeName}` : ''}`}>
          {productData?.name}
          {metalPurity && selectedMetalName ? ` | ${selectedMetalName}` : ''}
          {appendDesc && selectedSizeName ? ` | ${selectedSizeName}` : ''}
        </h1>
        {enableRating && showPDPRateSection && (
          <>
            {productData?.ratingsResponse?.aggregateRating && (
              <div className="rating-popup" style={{ display: 'flex', justifyContent: 'center' }}>
                <RatingLabel {...radioProps} />
              </div>
            )}
          </>
        )}
        {this.props.originalPrice && this.props.discountPrice ? (
          <div className="prod-price-section">
            <div className="prod-sp">{displayValueWithSymbol(this.props?.discountPrice)}</div>
            {this.props.originalPrice !== this.props.discountPrice && hideMRP && (
              <div className="prod-price-sec">
                <span className="prod-mrp" aria-label={SHOW_MRP_TEXT}>{SHOW_MRP_TEXT}</span>
                <span className="prod-cp">{displayValueWithSymbol(this.props?.originalPrice)}</span>
                {parseInt(this.props.discountPercentage) > 0 && (
                  <span className="prod-discnt">&nbsp;({this.props?.discountPercentage})</span>
                )}
              </div>
            )}
          </div>
        ) : (
          <div className="prod-price-section">
            <div className="prod-sp">{displayValueWithSymbol(sellingPrice)}</div>
            {strikePrice && sellingPrice !== strikePrice && hideMRP && (
              <div className="prod-price-sec">
                <span className="prod-mrp" aria-label={SHOW_MRP_TEXT}>{SHOW_MRP_TEXT}</span>
                <span className="prod-cp">{strikePrice}</span>
                {parseInt(discountPercent) > 0 && (
                  <span className="prod-discnt">&nbsp;({discountPercent})</span>
                )}
              </div>
            )}
          </div>
        )}
        {newDesignLuxe ? (
          <div className="tax-text" aria-label="Price inclusive of all taxes">Price inclusive of all taxes</div>
        ) : (
          <div className="prod-gst" aria-label={this.textContent?.additionalGST}>{this.textContent?.additionalGST}</div>
        )}
        <Freebies
          giftItemsList={freebiesItemsList}
          totalGiftCount={freebiesItemsCount}
          isDesktop={true}
        />
        <div className="trustMarkerImages">
          {trustmarkerImages.map(image => {
            return <img src={replaceWithJioCDN(image.url)} />;
          })}
        </div>

        {productData.potentialPromotions && (
          <>
            <Feature featureName="offerPrice">
              <Variant id="0">
                <Promotions
                  offerPriceShow={false}
                  potentialPromotions={productData.potentialPromotions}
                  categoryTags={categoryTags}
                  price={sellingPrice}
                  stockLevelStatus={stockLevelStatus}
                  showPriceReveal={isDuringSale}
                  isPriceReveal={isDuringSale || isPreBuzz}
                  newDesignLuxe={newDesignLuxe}
                  isEarlyAccessUser={isEarlyAccessUser}
                  isQuickView
                />
              </Variant>
              <Variant id="1">
                <Promotions
                  offerPriceShow
                  potentialPromotions={productData.potentialPromotions}
                  categoryTags={categoryTags}
                  price={sellingPrice}
                  stockLevelStatus={stockLevelStatus}
                  showPriceReveal={isDuringSale}
                  isPriceReveal={isDuringSale || isPreBuzz}
                  newDesignLuxe={newDesignLuxe}
                  isEarlyAccessUser={isEarlyAccessUser}
                  isQuickView
                />
              </Variant>
            </Feature>
          </>
        )}
        {colorVariant && (
          <ColorVariant
            colorVariantData={colorVariant}
            viewRender={this.props.viewRender}
            onSelectColor={onSelectColor}
            metalPurity={metalPurity}
            newDesignLuxe={newDesignLuxe}
            productData={productData}
          />
        )}
        {sizeVariant?.length > 0 && (
          <SizeVariant
            sizeVariantData={sizeVariant}
            sizeToolTip={sizeToolTip}
            sizeFormat={sizeFormat}
            viewRender={this.props.viewRender}
            hideSizes={hideSizes}
            appendDesc={appendDesc}
            qualifierKey={qualifierKey}
            newDesignLuxe={newDesignLuxe}
          />
        )}
        {!newDesignLuxe && this.props.stockMessage && (
          <div className="prod-stock-status">{this.props?.stockMessage}</div>
        )}
        <div className="pdp-cart-buttons">
          {stockLevelStatus === 'outOfStock' ? (
            <div className="product-oos-block">
              <div className="oos-heading" aria-label="OUT OF STOCK!">OUT OF STOCK!</div>
              <div className="oos-item-unavailable">Sorry, this item is currently unavailable</div>
            </div>
          ) : (
            <AddToCart
              productData={productData.code}
              selectedSizeName={selectedSizeName}
              data={productData}
              newDesignLuxe={newDesignLuxe}
              averageRating={productData?.ratingsResponse?.aggregateRating?.averageRating}
              numUserRatings={productData?.ratingsResponse?.aggregateRating?.numUserRatings}
            />
          )}
          <div className="prod-detail-url">
            <a onClick={this.onActionClick} className="prod-detail-link" tabIndex={0} role="button">
              <div className="btn-product-details">Product Details</div>
            </a>
          </div>
          <div className="quickview-social-sharing">
            <a
              className="qv-fb"
              href={`https://www.facebook.com/sharer.php?u=${websiteURL}&amp;t=${pageTitle}`}
              target="_blank"
              title="Facebook"
              onClick={() => {
                let { baseProduct: baseProductCode = '', code = '' } = productData;
                generateEvent({
                  Event: 'Share',
                  value: {
                    Medium: 'Facebook',
                    ProductId: baseProductCode
                  }
                });
              }}
            >
              <div className="qv-fb-icon qv-social-sharing">
                <div className="social-tooltip">Share on facebook</div>
              </div>
            </a>

            <a
              className="qv-twitter"
              href={`https://twitter.com/intent/tweet?url=${websiteURL}`}
              target="_blank"
              title="Twitter"
              onClick={() => {
                let { baseProduct: baseProductCode = '', code = '' } = productData;
                generateEvent({
                  Event: 'Share',
                  value: {
                    Medium: 'Twitter',
                    ProductId: baseProductCode
                  }
                });
              }}
            >
              <div className="qv-twitter-icon qv-social-sharing">
                <div className="social-tooltip" aria-label="Tweet!">Tweet!</div>
              </div>
            </a>

            <a
              className="qv-pinterest"
              href={`http://pinterest.com/pin/create/button/?url=${websiteURL}&amp;description=${pageTitle}&amp;media=${websiteURL}${pdpSocialPrimaryImageUrl}`}
              target="_blank"
              title="Pinterest"
              onClick={() => {
                let { baseProduct: baseProductCode = '', code = '' } = productData;
                generateEvent({
                  Event: 'Share',
                  value: {
                    Medium: 'Pininterest',
                    ProductId: code
                  }
                });
              }}
            >
              <div className="qv-pinterest-icon qv-social-sharing">
                <div className="social-tooltip" aria-label="Pin It!">Pin It!</div>
              </div>
            </a>

            <a
              className="qv-gplus"
              href={`https://plus.google.com/share?url=${websiteURL}&amp;utm_content=${pageTitle}&amp;utm_campaign=&amp;utm_medium=share%2Bbutton`}
              target="_blank"
              title="Google+"
              onClick={() => {
                let { baseProduct: baseProductCode = '', code = '' } = productData;
                generateEvent({
                  Event: 'Share',
                  value: {
                    Medium: 'Google Plus',
                    ProductId: baseProductCode
                  }
                });
              }}
            >
              <div className="qv-gplus-icon qv-social-sharing">
                <div className="social-tooltip" aria-label="Share on Google+">Share on Google+</div>
              </div>
            </a>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  const { flags, popup } = state;

  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);

  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';
  const hurryMessageInventoryCap = getHurryMsgInvCap(flags);
  let stockMessage = '';
  const { selectedSizeStockLevel = {} } = popup;
  if (typeof selectedSizeStockLevel === 'object') {
    if (
      selectedSizeStockLevel.stockLevel <= hurryMessageInventoryCap &&
      selectedSizeStockLevel.stockLevel > 0
    ) {
      stockMessage = 'Hurry, Only few items left';
    }
    if (selectedSizeStockLevel.isLowStock) {
      stockMessage = `Hurry, Only ${selectedSizeStockLevel.stockLevel} items left`;
    }
  }
  return {
    selectedSizeStockLevel: state.popup.selectedSizeStockLevel,
    selectedSizeName: state.product.selectedSizeName,
    discountPrice: state.popup.discountPrice,
    originalPrice: state.popup.originalPrice,
    discountPercentage: state.popup.discountPercentage,
    stockMessage,
    newDesignLuxe,
    earlyAccessFlag: getEarlyAccessFlag(flags),
    currentStore: storeName,
    priceRevealV2WebFeatureFlag: getPriceRevealV2WebFeatureFlag(flags),
    priceRevealV2WebData: getPriceRevealWebData(flags),
    priceRevealLUXEFlag: getPriceRevealLUXEFlag(flags),
    metadata: state.metaData,
    enableRating: getEnableRating(state?.flags,state),
    showPDPRateSection: getShowPDPRateSection(state?.flags),
    storesForHidingMRP: getStoresForHidingMRP(state),
    ratingsColor: getRatingsColorConfig(state?.flags)
  };
};

export default Description = connect(mapStateToProps)(Description);
